export default __webpack_public_path__ + "static/big-data-2f48dcedbcb2ba5c1b31810c71fb9a63.png";